import instance from './axiosInstance';

const routerPrefix = '/alerts/manual';

export function getAlerts(options = {}) {
  return instance.get(`${routerPrefix}`, options);
}

export function getEvent(eventId, options = {}) {
  return instance.get(`${routerPrefix}/event/${eventId}`, options);
}

export function getEventsByAlert(alertId, options = {}) {
  return instance.get(`${routerPrefix}/${alertId}/events`, options);
}

export function getRecentAlerts(query) {
  return instance.get(`${routerPrefix}/recent?type=${query.type}&limit=${query.limit}`);
}

export function getAlertList(options = {}) {
  return instance.get(`${routerPrefix}/list`, options);
}

export function createAlert(reqBody, options = {}) {
  return instance.post(`${routerPrefix}`, reqBody);
}

export function updateAlert(reqBody, options = {}) {
  return instance.put(`${routerPrefix}`, reqBody);
}

export function toggleAlert(alertId, reqBody, options = {}) {
  return instance.put(`${routerPrefix}/${alertId}/toggle`, reqBody, options);
}

export function deleteAlert(alertId, reqBody = {}, options = {}) {
  return instance.put(`${routerPrefix}/${alertId}/delete`, reqBody, options);
}
